interface Dimension {
  height: string;
  width: string;
}

interface Size {
  xxs: Dimension;
  xs: Dimension;
  s: Dimension;
  m: Dimension;
  l: Dimension;
}

interface BrandLogoDimensions {
  short: Size;
  long: Size;
  tiny?: Size;
}

const createDimensions = (
  short: Size,
  long: Size,
  tiny?: Size,
): BrandLogoDimensions => ({
  short,
  long,
  tiny,
});

const EDShort: Size = {
  xxs: { height: "11px", width: "44px" },
  xs: { height: "18px", width: "71px" },
  s: { height: "22px", width: "86px" },
  m: { height: "28px", width: "110px" },
  l: { height: "38px", width: "149px" },
};

const EDLong: Size = {
  xxs: { height: "11px", width: "67px" },
  xs: { height: "18px", width: "131px" },
  s: { height: "22px", width: "160px" },
  m: { height: "28px", width: "203px" },
  l: { height: "38px", width: "283px" },
};

const GOShort: Size = {
  xxs: { height: "11px", width: "47px" },
  xs: { height: "18px", width: "75px" },
  s: { height: "22px", width: "92px" },
  m: { height: "28px", width: "117px" },
  l: { height: "38px", width: "158px" },
};

const GOLong: Size = {
  xxs: { height: "11px", width: "47px" },
  xs: { height: "18px", width: "75px" },
  s: { height: "24px", width: "100px" },
  m: { height: "32px", width: "133px" },
  l: { height: "48px", width: "200px" },
};

const OPShort: Size = {
  xxs: { height: "11px", width: "72px" },
  xs: { height: "18px", width: "109px" },
  s: { height: "22px", width: "133px" },
  m: { height: "28px", width: "169px" },
  l: { height: "38px", width: "230px" },
};

const OPTiny: Size = {
  xxs: { height: "11px", width: "40px" },
  xs: { height: "18px", width: "72px" },
  s: { height: "22px", width: "89px" },
  m: { height: "28px", width: "113px" },
  l: { height: "38px", width: "153px" },
};

const OPLong: Size = {
  xxs: { height: "11px", width: "88px" },
  xs: { height: "18px", width: "109px" },
  s: { height: "24px", width: "145px" },
  m: { height: "32px", width: "203px" },
  l: { height: "48px", width: "304px" },
};

const TRShort: Size = {
  xxs: { height: "11px", width: "36px" },
  xs: { height: "18px", width: "58px" },
  s: { height: "22px", width: "71px" },
  m: { height: "28px", width: "90px" },
  l: { height: "38px", width: "122px" },
};

const TRLong: Size = {
  xxs: { height: "11px", width: "67px" },
  xs: { height: "18px", width: "120px" },
  s: { height: "22px", width: "147px" },
  m: { height: "28px", width: "160px" },
  l: { height: "38px", width: "254px" },
};

export const logoDimensions = {
  ED: createDimensions(EDShort, EDLong),
  GO: createDimensions(GOShort, GOLong),
  OP: createDimensions(OPShort, OPLong, OPTiny),
  TR: createDimensions(TRShort, TRLong),
};
